import axios from 'axios';

const clienteAxios = axios.create({
    baseURL: process.env.REACT_APP_URL_WS_CLAVEUNICA
    //baseURL: '//qa-ws-claveunica.uss.cl/'
    //baseURL : '//localhost:8080/'
});

export default clienteAxios;
